import { render, staticRenderFns } from "./printYCQuoted.vue?vue&type=template&id=1f815a2c&scoped=true&"
import script from "./printYCQuoted.vue?vue&type=script&lang=js&"
export * from "./printYCQuoted.vue?vue&type=script&lang=js&"
import style0 from "./printYCQuoted.vue?vue&type=style&index=0&id=1f815a2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f815a2c",
  null
  
)

component.options.__file = "printYCQuoted.vue"
export default component.exports